var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core';
import { getSpellCategory } from '@timeflies/common';
import { SpellImage } from '@timeflies/sprite-image';
import React from 'react';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var spellRole = _a.spellRole, padding = _a.padding;
            return ({
                display: 'inline-block',
                backgroundColor: palette.spellCategories[getSpellCategory(spellRole)],
                padding: padding,
            });
        }
    });
});
export var SpellIcon = function (props) {
    var classes = useStyles(props);
    var size = props.size - props.padding * 2;
    return (React.createElement("div", { className: classes.root },
        React.createElement(SpellImage, __assign({}, props, { size: size }))));
};
